@if (errorMessage) {
<div class="error-div">
  <mat-card class="error-message">
    <mat-card-header>
      An Error occurred when loading this job for booking. The details of the
      error are shown below.
    </mat-card-header>
    <mat-card-content
      ><br />
      {{ errorMessage.message }}
    </mat-card-content>
    <mat-card-footer>
      If this error is unexpected, then please send the above error to your
      system administrator or support contact.
    </mat-card-footer>
  </mat-card>
</div>
} @if (job) {
<mat-toolbar color="accent">
  <mat-toolbar-row>
    @for (visit of newVisitList; track visit) {
    <span class="visit-button">
      @if (selectedVisitId === visit.id) {
      <button
        (click)="selectedVisitId = visit.id"
        color="primary"
        mat-raised-button
      >
        {{ newVisitList.indexOf(visit) + 1 }} of {{ newVisitList.length }} -
        {{ visit.visitType.description }}
      </button>
      } @if (selectedVisitId !== visit.id) {
      <button
        (click)="selectedVisitId = visit.id"
        color="accent"
        mat-flat-button
      >
        {{ newVisitList.indexOf(visit) + 1 }} of {{ newVisitList.length }} -
        {{ visit.visitType.description }}
      </button>
      }
    </span>
    }
  </mat-toolbar-row>
</mat-toolbar>
} @if (job && selectedVisitId) {
<div class="job-booking-container">
  <app-visit-booking
    (booked)="handleBooked($event)"
    [exitOnCompletion]="true"
    [visitId]="selectedVisitId"
  ></app-visit-booking>
</div>
}
